// autogenerated module
import {css} from 'lit-element';
export const style = css`.tooltip{width:var(--tooltip-inline-size, 240px)}.tooltip-title{font:600 ultra-condensed 14px / 20px SpeziaWebVariable;letter-spacing:0px;text-decoration:none;text-transform:none;padding:.5rem .75rem;color:var(--vvd-color-primary)}`;